<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157" text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu v-if="item.visible" :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.subs" v-show="threeItem.visible" :key="i" :index="threeItem.index">{{ threeItem.title }}</el-menu-item>
              </el-submenu>
              <template v-else>
                <el-menu-item :index="subItem.index" v-if="subItem.visible" :key="subItem.index">{{ subItem.title }}</el-menu-item>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item v-if="item.visible" :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { getRoles, getNavigation, setNavigation } from '@/utils/localStorage.js';
import { getUserNavigationApi, getParentPermissionApi } from '@/api/new_admin_user.js';
import bus from '../common/bus';
export default {
  data() {
    return {
      collapse: false,
      navegationList: [],
      items: [
        {
          icon: 'el-icon-lx-home',
          index: '/dashboard',
          title: '系统首页',
          visible: '147',
        },
        {
          icon: 'el-icon-lx-settings',
          index: '/setting',
          title: '系统设置',
          visible: '148',
          subs: [
            {
              index: '/setting-user',
              title: '用户管理',
              visible: '152',
            },
            {
              index: '/setting-role',
              title: '角色管理',
              visible: '153',
            },
            {
              index: '/setting-permission',
              title: '权限管理',
              visible: '154',
            },
            // {
            //   index: '/setting-gameStatus',
            //   title: '游戏现状态',
            //   visible: '245',
            // },
            {
              index: '/faq-type/game',
              title: '工单游戏配置',
              visible: '170',
            },
            {
              index: '/setting-nickname',
              title: '昵称管理',
              visible: '431',
            },
          ],
        },
        // {
        //   icon: 'el-icon-lx-cascades',
        //   index: 'work',
        //   title: '工单管理',
        //   visible: '149',
        //   subs: [
        //     {
        //       index: '/work-work_sn',
        //       title: '自助工单',
        //       visible: '155',
        //     },
        //     {
        //       index: '/work-manMadeOrder',
        //       title: '人工工单',
        //       visible: '155',
        //     },

        //     // {
        //     //   index: '/work-work_statistics',
        //     //   title: '工单统计',
        //     //   visible: '157',
        //     // },
        //   ],
        // },

        {
          icon: 'el-icon-lx-news',
          index: 'customer',
          title: '客服交接',
          visible: '150',
          subs: [
            {
              index: '/send-verificationCode',
              title: '发送验证码',
              visible: '166',
            },
            {
              index: '/customer-problem',
              title: '问题交接',
              visible: '166',
            },
            {
              index: '/customer-gift_bag',
              title: '安抚礼包',
              visible: '167',
            },
          ],
        },
        {
          icon: 'el-icon-lx-news',
          index: 'dpartmentSmmary',
          title: '运营汇总',
          visible: '171',
          subs: [
            {
              index: '/dpartmentSmmary-CPGameAdmin',
              title: 'CP游戏后台',
              visible: '258',
            },
            // {
            //   index: '/dpartmentSmmary-gameOperation',
            //   title: '游戏运营对接',
            //   visible: '250',
            // },
            // {
            //   index: '/dpartmentSmmary-complaint',
            //   title: '投诉记录',
            //   visible: '190',
            // },
            {
              index: '/dpartmentSmmary-packageSwitchStrategy',
              title: '切包策略配置',
              visible: '469',
            },
            {
              index: '/dpartmentSmmary-invoiceEntityConfig',
              title: '自动开票主体配置',
              visible: '474',
            },
            {
              index: '/dpartmentSmmary-invoiceRecord',
              title: '开票记录',
              visible: '479',
            },
            {
              index: '/dpartmentSmmary-serviceRecord',
              title: '玩家建议',
              visible: '202',
            },
            {
              index: '/dpartmentSmmary-indulge_link',
              title: '防沉迷链接',
              visible: '180',
            },
            {
              index: '/dpartmentSmmary-applicationGoods',
              title: '物品补发申请',
              visible: '216',
            },
            {
              index: '/dpartmentSmmary-bill_record',
              title: '发票记录',
              visible: '164',
            },
            // {
            //   index: '/dpartmentSmmary_uploadFile',
            //   title: '文件上传',
            //   visible: '172',
            // },
          ],
        },
        {
          icon: 'el-icon-lx-news',
          index: 'faq',
          title: 'FAQ知识库',
          visible: '151',
          subs: [
            {
              index: '/faq-index',
              title: 'FAQ知识库',
              visible: '168',
            },
            // {
            //   index: '/faq-center',
            //   title: '个人中心',
            //   visible: '169',
            // },
          ],
        },
        // {
        //   icon: 'el-icon-lx-cascades',
        //   index: 'configureSummary',
        //   title: '配置汇总',
        //   visible: '227',
        //   subs: [
        //     // {
        //     //   index: '/work-work_kefu',
        //     //   title: '工单客服',
        //     //   visible: '156',
        //     // },
        //     {
        //       index: '/work-work_prohibition',
        //       title: '封禁管理',
        //       visible: '158',
        //     },
        //     {
        //       index: '/work-work_game_vips',
        //       title: 'vip管理',
        //       visible: '159',
        //     },
        //     {
        //       index: '/work-work_question_config',
        //       title: '常见问题',
        //       visible: '160',
        //     },
        //     {
        //       index: '/work-work_question_type',
        //       title: '常见问题类型',
        //       visible: '161',
        //     },
        //     {
        //       index: '/work-work_reply',
        //       title: '快捷回复设置',
        //       visible: '162',
        //     },
        //     {
        //       index: '/work-data_statistics',
        //       title: '数据统计',
        //       visible: '163',
        //     },
        //     {
        //       index: '/work-early-warning',
        //       title: '报警预警',
        //       visible: '234',
        //     },
        //     {
        //       index: '/work-commentType',
        //       title: '评价类型',
        //       visible: '339',
        //     },
        //     {
        //       index: '/work-openHookAccount',
        //       title: '开挂账号管理',
        //       visible: '358',
        //     },
        //   ],
        // },
        {
          icon: 'el-icon-receiving',
          index: 'vipQualityTest',
          title: 'VIP质检',
          visible: '274',
          subs: [
            {
              index: '/dutyList',
              title: '客服昵称',
              visible: '276',
            },
          ],
        },
        {
          icon: 'el-icon-lx-search',
          index: '/userInfoQuery',
          title: '用户信息查询',
          visible: '435',
        },
        {
          icon: 'el-icon-chat-dot-round',
          index: 'wechatWork',
          title: '企微会话记录',
          visible: '402',
          subs: [
            {
              index: '/employeeList',
              title: '企微会话查询',
              visible: '403',
            },
            {
              index: '/qwAiQualityList',
              title: 'AI质检',
              visible: '438', // TODO: 待后端分配正式 visible id
            },
            {
              index: '/qwAiQualityDashboard',
              title: 'AI质检看板',
              visible: '439', // TODO: 待后端分配正式 visible id
            },
          ],
        },
        {
          icon: 'el-icon-lx-news',
          index: 'zfbMerchant',
          title: '商户号投诉处理',
          visible: '413',
          subs: [
            {
              index: '/wx_merchant_complaint_handle',
              title: '微信商户号',
              visible: '422',
            },
            {
              index: '/zfb_merchant_complaint_handle',
              title: '支付宝商户号',
              visible: '412',
            },
          ],
        },
        {
          icon: 'el-icon-receiving',
          index: '/ordinaryReport',
          title: '普客工作汇报',
          visible: '291',
        },
        // {
        //   icon: 'el-icon-receiving',
        //   index: 'workData',
        //   title: '客服数据汇总',
        //   visible: '292',
        //   subs: [
        //     {
        //       index: '/ordinaryData',
        //       title: '普客客服数据',
        //       visible: '293',
        //     },
        //     {
        //       index: '/vipData',
        //       title: 'vip客服数据',
        //       visible: '294',
        //     },
        //     {
        //       index: '/testData',
        //       title: '质检客服数据',
        //       visible: '295',
        //     },
        //     {
        //       index: '/worksnData',
        //       title: '工单客服数据',
        //       visible: '296',
        //     },
        //   ],
        // },
        // {
        //   icon: 'el-icon-receiving',
        //   index: 'testAnalysis',
        //   title: '质检分析',
        //   visible: '297',
        //   subs: [
        //     {
        //       index: '/worksnAnalysis',
        //       title: '工单质检分析',
        //       visible: '298',
        //     },
        //     {
        //       index: '/vipAnalysis',
        //       title: 'vip质检分析',
        //       visible: '299',
        //     },
        //     {
        //       index: '/oridinaryAnalysis',
        //       title: '普客质检分析',
        //       visible: '300',
        //     },
        //     {
        //       index: '/weixinAnalysis',
        //       title: '微信质检分析',
        //       visible: '301',
        //     },
        //   ],
        // },
      ],
      pageItems: [

      ],
      hidePageItems: [
        {
          icon: 'el-icon-lx-home',
          index: '/dashboard',
          title: '系统首页',
          visible: '147',
        },
        {
          icon: 'el-icon-receiving',
          index: '/ordinaryReport',
          title: '普客工作汇报',
          visible: '291',
        },
      ]
    };
  },
  computed: {
    onRoutes() {
      // return this.$route.path.replace('/', '');
      return this.$route.path;
    },
  },
  methods: {
    checkRouter(data) {
      let array = [];
      this.navegationList = this.navegationList.map((permissionItem) => Number(permissionItem));
      for (let item of data) {
        if (item.visible == 147 || item.visible == 291) {
          array.push(item);
        } else if (!item.subs) {
          // 无子菜单的独立顶级菜单项
          let p = {
            icon: item.icon,
            index: item.index,
            title: item.title,
            visible: this.navegationList.includes(Number(item.visible)),
          };
          array.push(p);
        } else {
          let p = {};
          p.icon = item.icon;
          p.index = item.index;
          p.title = item.title;
          p.visible = this.navegationList.includes(Number(item.visible));
          p.subs = [];
          for (let a of item.subs) {
            let q = {};
            q.icon = a.icon;
            q.index = a.index;
            q.title = a.title;
            q.visible = a.visible === 'all' ? true : this.navegationList.includes(Number(a.visible));
            p.subs.push(q);
          }
          array.push(p);
        }
      }
      this.items = array;
      // console.log(this.items)
    },
    getUserNavigation() {
      getParentPermissionApi()
        .then((response) => {})
        .catch((error) => {});
      getUserNavigationApi()
        .then((response) => {
          // console.log(response)
          setNavigation(JSON.stringify(response.data.data));
        })
        .catch((error) => {});
    },
  },
  created() {
    this.getUserNavigation();
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', (msg) => {
      this.collapse = msg;
    });
  },
  mounted() {
    let that = this;
    setTimeout(function () {
      const hide_page = localStorage.getItem('hide_page');
      that.navegationList = JSON.parse(getNavigation());
      that.checkRouter(hide_page == 1 ? that.hidePageItems : that.items);
      // console.log(that.navegationList)
    }, 1000);
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.sidebar > ul {
  height: 100%;
}
</style>
